var p = { exports: {} };
export {
  p as __module
};
